export default (api) => {
    return {
        index: (challenge_id, options) => api.get(`challenge_versions/${challenge_id}/entities`, options),
    }
}
